import { render, staticRenderFns } from "./UnsubscriptionAnnounce.vue?vue&type=template&id=65bf9105&scoped=true&"
import script from "./UnsubscriptionAnnounce.vue?vue&type=script&lang=ts&"
export * from "./UnsubscriptionAnnounce.vue?vue&type=script&lang=ts&"
import style0 from "./UnsubscriptionAnnounce.vue?vue&type=style&index=0&id=65bf9105&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65bf9105",
  null
  
)

export default component.exports